import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import MuiTypography from '@material-ui/core/Typography';
import SEADEMO_LOGO from '../../../assets/staticsCalls/whoweare/sea2demo.png';
import SEADEMO_CONSORZIO from '../../../assets/staticsCalls/innovation/seademo_consorzio.png';
import SEADEMO_INFOGRAFICA_IT from '../../../assets/staticsCalls/innovation/seademo_infografica_it.jpg';
import SEADEMO_INFOGRAFICA_EN from '../../../assets/staticsCalls/innovation/seademo_infografica_en.jpg';

const Typography = withStyles((theme) => ({
  body1: {
    fontFamily: 'Lato',
  },
}))(MuiTypography);

function Seademo() {
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState(i18n.language);

  useEffect(() => {
    i18n.on('languageChanged', (t) => {
      setLocale(t);
    });
  }, [locale, i18n]);

  return (
    <>
      <Helmet>
        <title>
          {t('common:app.name')} | {t('pages:innovation.seademo')}
        </title>
      </Helmet>
      <Grid container justify="center" direction="row" wrap="wrap" spacing={3}>
        <Grid item xs={12}>
          <Box
            style={{
              backgroundColor: 'white',
              margin: '20px 0',
              paddingBottom: '50px',
            }}
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
          >
            <img
              style={{ margin: '20px 0' }}
              alt="Seademo Logo"
              src={SEADEMO_LOGO}
            ></img>
            <Typography
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginBottom: '20px',
                padding: '0px 50px',
                textAlign: 'justify',
              }}
              gutterBottom
            >
              {t('pages:innovation.seademo_page.consorzium')}
            </Typography>
            <img
              style={{ marginBottom: '20px', width: '80%' }}
              alt="Seademo Logo"
              src={SEADEMO_CONSORZIO}
            ></img>
            <Typography
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginBottom: '20px',
                padding: '0 44px 44px 44px',
                textAlign: 'justify',
                lineHeight: '1.05',
                color: 'rgb(128,128,128)',
              }}
              gutterBottom
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: t('pages:innovation.seademo_page.text'),
                }}
              ></p>
            </Typography>
            <img
              style={{ margin: '0px', width: '95%' }}
              alt="Seademo"
              src={
                locale === 'en'
                  ? SEADEMO_INFOGRAFICA_EN
                  : SEADEMO_INFOGRAFICA_IT
              }
            ></img>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Seademo;
